import { updateQuantity } from "@/Api/StockSlotController";
import { ViewImportOrder } from "@/Models/Views/ViewImportOrder";
import { ViewStockSlot } from "@/Models/Views/ViewStockSlot";
import { Form, Modal, InputNumber, message } from "antd";
import React, { useEffect, useState } from "react";
import { useCallback } from "react";

function EditQuantityForm({ onCancel, data }: { data: ViewStockSlot, onCancel: () => void }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const onOk = useCallback(async () => {
        setLoading(true);
        message.destroy();
        try {
            const d1 = await form.validateFields().then(async s=>{
              let stockCode=data.stockCode.substring(0,3);
                if(!s["quantity"]&&s["quantity"]!=0){
                    message.error('请填写修改的数量！');
                }
                else if(/^[0-9]{6}$/.test(data.stockCode)&&s["quantity"]==0){
                    message.error('立库货物库存数量不能改为0 ！');
                }
                else if(stockCode=='A1-'||stockCode=='B1-'||stockCode=='C1-'){
                    message.error('A1-、B1-、C1-开头的托盘条码不能修改数量！');
                }
                else{
                    const res =await updateQuantity(data.id, s["quantity"]);
                    data.quantity=s["quantity"];
                    onCancel();
                }
            })            
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }, [data, form, onCancel]); 
    return <Modal visible confirmLoading={loading} title={`修改“ ${data.goodsName} ”的数量`} width={360} onCancel={onCancel} onOk={onOk}>
        <Form form={form} labelAlign="right" initialValues={data} labelCol={{ span: 8 }}>
            <Form.Item name="quantity" label="数量" required >
                <InputNumber min={0}   precision={0} />
            </Form.Item>
        </Form>
    </Modal>;
}

export default EditQuantityForm;